import styled from "styled-components";

export const WinSectionWrap = styled.div`
  width: 100%;
`;
